// SERVICES
import RegionService from "@/services/region.service";


// STATE
const state = {
	listAll: [],
	childList: [],
	list: [],
	districtList: []
};

// GETTERS
const getters = {

}

// ACTIONS
const actions = {
	async listAll({ commit }) {
		try {
			const res = await RegionService.listAll()
			await commit('setListResponseAll', res);
		} catch (error) {
			await commit('setListResponseAll', []);
		}
	},
	async getList({ commit }) {
		try {
			const res = await RegionService.getParent()
			await commit('setListResponse', res);
		} catch (error) {
			await commit('setListResponse', error.response.data);
		}
	},
	async getByParentId({ commit }, data) {
		try {
			const res = await RegionService.getByParentId(data.id)
			await commit('setChildList', res.data);
		} catch (error) {
		}
	},
	async getDistrictByParentId({ commit }, data) {
		try {
			const res = await RegionService.getByParentId(data.id)
			await commit('setDistrictList', res.data ? res.data : []);
		} catch (error) {
		}
	},
}

// MUTATIONS
const mutations = {
	setDistrictList(state, data) {
		state.districtList = data
	},
	setListResponseAll(state, payload) {
		state.listAll = payload.data
	},
	setListResponse(state, payload) {
		state.list = payload.data
	},
	setChildList(state, payload) {
		state.childList = payload
	},
}

export const region = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
